const transparentMimeTypes = ['image/png', 'image/webp', 'image/gif', 'image/svg+xml', 'image/avif'];

function loadImageElement(file) {
	return new Promise((resolve, reject) => {
		const url = URL.createObjectURL(file);
		const image = new Image();

		image.addEventListener('load', () => {
			URL.revokeObjectURL(url);
			resolve(image);
		});

		image.addEventListener('error', () => {
			URL.revokeObjectURL(url);
			reject(new Error('Obrázek se nepodařilo načíst.'));
		});

		image.src = url;
	});
}

async function loadImage(file) {
	if (typeof createImageBitmap === 'function') {
		try {
			// from-image respektuje EXIF orientaci fotek z mobilu
			return await createImageBitmap(file, {imageOrientation: 'from-image'});
		} catch (error) {
			// fallback níž
		}
	}

	return loadImageElement(file);
}

// Zmenší obrázek tak, aby jeho delší strana byla nejvýš maxSize (poměr stran zůstává),
// menší obrázky nezvětšuje. PNG/WEBP/GIF vrací jako PNG, aby zůstala průhlednost,
// ostatní formáty jako JPEG.
export default async function resizeImageFile(file, maxSize = 350) {
	const image = await loadImage(file);
	const sourceWidth = image.width || image.naturalWidth || 0;
	const sourceHeight = image.height || image.naturalHeight || 0;

	if (sourceWidth < 1 || sourceHeight < 1) {
		throw new Error('Obrázek se nepodařilo načíst.');
	}

	const scale = Math.min(1, maxSize / Math.max(sourceWidth, sourceHeight));
	const targetWidth = Math.max(1, Math.round(sourceWidth * scale));
	const targetHeight = Math.max(1, Math.round(sourceHeight * scale));

	const canvas = document.createElement('canvas');
	canvas.width = targetWidth;
	canvas.height = targetHeight;

	const context = canvas.getContext('2d');
	context.imageSmoothingEnabled = true;
	context.imageSmoothingQuality = 'high';
	context.drawImage(image, 0, 0, sourceWidth, sourceHeight, 0, 0, targetWidth, targetHeight);

	if (typeof image.close === 'function') {
		image.close();
	}

	const keepTransparency = transparentMimeTypes.includes(file.type);
	const outputType = keepTransparency ? 'image/png' : 'image/jpeg';
	const outputExtension = keepTransparency ? 'png' : 'jpg';

	const blob = await new Promise((resolve, reject) => {
		canvas.toBlob((createdBlob) => {
			if (!createdBlob) {
				reject(new Error('Obrázek se nepodařilo zpracovat.'));
				return;
			}

			resolve(createdBlob);
		}, outputType, keepTransparency ? undefined : 0.92);
	});

	return {blob, extension: outputExtension, width: targetWidth, height: targetHeight};
}
